/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Salutationinletter2Inputs */

const de__field_salutationinletter2 = /** @type {(inputs: _Field_Salutationinletter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrede im Brief`)
};

/**

* @param {_Field_Salutationinletter2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_salutationinletter2 = /** @type {((inputs?: _Field_Salutationinletter2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Salutationinletter2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_salutationinletter2(inputs)
});
export { _field_salutationinletter2 as "_field_salutationInLetter" }